




















































































import { Component, Vue, Watch, Provide, Prop } from "vue-property-decorator";

import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
} from "@/api/index";
import {
  GetAudioQualityScriptListReq,
  Bool,
  OpenTicketReq,
  AudioQualityScriptData,
  SaveAudioQualityScriptReq,
} from "@/pbjs/external/ticket/ticket_pb";
import {
  ListUserGroupByTypeReq,
  ListUserGroupByMutiTypeReq,
} from "@/pbjs/external/auth/auth_pb";
import { ExecType } from "@/pbjs/xcommon/enum_pb";
import { timeFormat, downloadFile, setValue } from "@/utils/index";
import {
  SearchUserReq,
  BatchGetLoginInfoReq,
  GetOutSourceInfoReq,
} from "@/pbjs/external/user/user_pb";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";

@Component({
  name: "addnewTalkPoint",
  components: {
    MaskComponent: () => import("./Mask.vue"),
  },
})
export default class addnewTalkPoint extends Vue {
  @Prop() flag: any;
  @Prop() dataRes: any;
  @Provide() private userForm: any = {
    TalkPointName: null,
    keywordsPhrases: null,
  };
  @Provide() private dynamicTags: any = [];
  @Provide() private inputVisible: boolean = false;
  @Provide() private showDialogTypeId: number = 0;
  @Provide() private inputValue: any = "";

  //   private created(){
  //       this.addNewPoint(this.flag,this.dataRes)
  //   }
  @Watch("flag")
  onAmountChanged(val: number | null) {
    console.log(val);

    if (val !== -7) {
      this.showDialogTypeId = this.dataRes.id;
      this.userForm.TalkPointName = this.dataRes.scriptname;
      this.dynamicTags = this.dataRes.scripttextList.split(",");
    } else {
      this.showDialogTypeId = -1;
      this.userForm.TalkPointName = "";
      this.dynamicTags = [];
    }
  }
  private handleClose(tag: any) {
    this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
  }

  private showInput() {
    this.inputVisible = true;
    this.$nextTick(() => {
      (this.$refs.saveTagInput as any).$refs.input.focus();
      // this.$refs.saveTagInput.$refs.input.focus();
    });
  }
  private hideMaskVue() {
    this.$emit("hideManualUpgradeTicketDialogue", {
      hidden: true,
      val: null,
    });
  }
  private closeDialog() {
    this.$emit("hideManualUpgradeTicketDialogue", {
      hidden: true,
      val: 0,
    });
  }
  private changeList() {
    this.$emit("changeList", {
      hidden: true,
      val: 0,
    });
  }
  private handleInputConfirm() {
    console.log(this.inputValue);

    let inputValue = this.inputValue;
    if (inputValue) {
      this.dynamicTags.push(inputValue);
    }
    this.inputVisible = false;
    this.inputValue = "";
  }
  private testRule() {
    // && this.dynamicTags.length > 0
    if (this.userForm.TalkPointName) {
      if (this.userForm.TalkPointName.length < 15) {
        return true;
      } else {
        this.$message({
          type: "error",
          message: "pls check the form value less than 15!",
        });
        return false;
      }
    } else {
      this.$message({
        type: "error",
        message: "pls check the form value!",
      });
      return false;
    }
  }
  //baocun
  private submitPoint() {
    console.log(this.dynamicTags, this.dynamicTags.join(","));
    if (this.testRule()) {
      let request = new SaveAudioQualityScriptReq();
      request.setCommonin(setCommon());
      request.setId(Number(this.showDialogTypeId));
      let requestAuto: any = new AudioQualityScriptData();
      requestAuto.setId();
      requestAuto.setScriptname(this.userForm.TalkPointName);
      requestAuto.addScripttext(this.dynamicTags.join(","));
      requestAuto.setScriptnum();
      requestAuto.setUid();
      requestAuto.setUsername();
      requestAuto.setCtime();
      requestAuto.setStatus(1);
      request.setData(requestAuto);
      console.log(request, "GetAudioQualityScriptListReq");
      ticketClient.saveAudioQualityScript(
        request,
        {},
        (err: any, response: any) => {
          if (response) {
            console.log(response, "response");
            let data: any = response.toObject();
            console.log(data, "toObject");
            if (data.commonout.code == 0) {
              this.$message.success("success");
              //   this.showDialogType=
              this.closeDialog();
              if (this.flag == -7) {
                this.userForm.TalkPointName = "";
                this.dynamicTags = [];
              }

              this.changeList();
            } else {
              this.$message.error(data.commonout.errmsg);
            }
            // let _fuc = this.getRoleListAPIFuc;
            // handleResponse(data, _fuc);
          }
          if (err) {
            errorMsg(err);
          }
        }
      );
    }
  }
}
